import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=0a22cfbd&scoped=true"
import script from "./GoodsDetail.vue?vue&type=script&lang=js"
export * from "./GoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=0a22cfbd&prod&lang=scss&scoped=true"
import style1 from "./GoodsDetail.vue?vue&type=style&index=1&id=0a22cfbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22cfbd",
  null
  
)

export default component.exports